import { toast } from 'sonner';

// Where a course builder certificate (Tech Learning, Finance Training or a Course Builder module) is shown
export const builderCertificatePath = (cert) => {
  if (!cert?.course_id) return null;
  if (cert.certificate_type === 'tech_learning_course') return `/tech-learning/builder-courses/${cert.course_id}/certificate`;
  if (cert.certificate_type === 'finance_training_course') return `/finance-training/builder-courses/${cert.course_id}/certificate`;
  if (cert.module_slug) return `/courses/${cert.module_slug}/course/${cert.course_id}/certificate`;
  return null;
};

// One toast the moment the last lesson/assessment is done and the certificate is issued
export const announceCertificate = (before, stats, navigate, path) => {
  if (!stats?.certificate_id || before?.certificate_id) return;
  toast.success('Course complete! Your certificate is ready.', {
    duration: 10000,
    action: { label: 'View certificate', onClick: () => navigate(path) },
  });
};
